import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLuxe from './LegalPageLuxe';

// CGV / CGU du fondateur (version du 2026-10-29, 32 articles en 4 parties), dans legal.json (cgv.parts).
//
// L'exclusion du droit de retractation (art. 20, L221-28 3°) n'est opposable que si elle est ECRITE et ACCEPTEE AVANT le paiement :
// la case a cocher de l'etape paiement (StepPayment.js) en fournit la preuve (date enregistree sur la commande).
//
// UNE SEULE VERSION, EN FRANCAIS (article 31 : « Elles sont redigees en francais ») : en anglais, la page affiche le texte francais
// precede d'une note, plutot qu'une traduction juridique non relue (l'ancienne traduction de 2026-10-01 ne correspondait plus).
export default function CGVLuxe() {
  const { t, i18n } = useTranslation('legal');
  const fr = i18n.getFixedT('fr', 'legal');
  const parts = fr('cgv.parts', { returnObjects: true });
  return (
    <LegalPageLuxe
      title={i18n.language && i18n.language.startsWith('en') ? t('cgv.title') : fr('cgv.title')}
      updated={fr('cgv.updated')}
      note={i18n.language && i18n.language.startsWith('en') ? t('cgv.frenchOnlyNote') : null}
      intro={fr('cgv.intro')}
      parts={Array.isArray(parts) ? parts : []}
    />
  );
}
